import { MappedReservedTimes } from 'components/Form/BDatePicker';
import { FormAction } from 'hooks/useForm';
import { Dispatch, useEffect, useState } from 'react';
import { dateService } from 'services/DateService';
import { VehicleBasedDemandState } from 'types/demand.type';

export function usePriceWidgetHarborIntersections(
  state: VehicleBasedDemandState,
  dispatch: Dispatch<FormAction<VehicleBasedDemandState>>,
  mappedReservedTimes: MappedReservedTimes
) {
  const dayjs = dateService.getDayjs();
  const [lockHarborsOtherThanThis, setLockHarborsOtherThanThis] = useState<
    number | null
  >(null);

  const checkInterception = (date: Date, isStart: boolean) => {
    const formattedDate = dateService.getFormattedDate(date);
    const hour = dayjs(date).hour();
    let rezervedTimeForDate = mappedReservedTimes[formattedDate];
    let offset = isStart ? -1 : 0;
    if (isStart && hour === 0) {
      const yesterday = dayjs(date).subtract(1, 'day').toDate();
      const formattedYesterday = dateService.getFormattedDate(yesterday);
      rezervedTimeForDate = mappedReservedTimes[formattedYesterday];
      offset = 23;
    }
    if (rezervedTimeForDate) {
      const previousReservedHour = rezervedTimeForDate.find((t) => {
        return t.hour === hour + offset && !t.isOffset;
      });
      return previousReservedHour?.harborId ?? null;
    }
    return null;
  };

  const isSomeDateInterceptsWithReservedDates = (
    date: Date,
    duration: number
  ) => {
    const selectedHarbors: { start: number | null; end: number | null } = {
      start: null,
      end: null,
    };
    selectedHarbors.start = checkInterception(date, true);

    const endDate = dateService
      .getEndDateFromHourDuration(date, duration)
      .toDate();
    selectedHarbors.end = checkInterception(endDate, false);

    if (selectedHarbors.start && selectedHarbors.end) {
      dispatch({
        type: 'harbor',
        payload: selectedHarbors.start,
      });
      dispatch({
        type: 'endHarbor',
        payload: selectedHarbors.end,
      });
      setLockHarborsOtherThanThis(selectedHarbors.start);
      return;
    }
    if (selectedHarbors.start) {
      dispatch({
        type: 'harbor',
        payload: selectedHarbors.start,
      });
      dispatch({
        type: 'endHarbor',
        payload: selectedHarbors.start,
      });
      setLockHarborsOtherThanThis(selectedHarbors.start);
      return;
    }
    if (selectedHarbors.end) {
      dispatch({
        type: 'harbor',
        payload: selectedHarbors.end,
      });
      dispatch({
        type: 'endHarbor',
        payload: selectedHarbors.end,
      });
      setLockHarborsOtherThanThis(selectedHarbors.end);
      return;
    }
    dispatch({
      type: 'endHarbor',
      payload: state.harbor,
    });
    setLockHarborsOtherThanThis(null);
  };

  useEffect(() => {
    if (state.date) {
      isSomeDateInterceptsWithReservedDates(state.date, state.duration);
    }
  }, [state.date, state.duration]);

  return {
    lockHarborsOtherThanThis,
  };
}
